// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-22c61ef8] #openFile,[data-v-22c61ef8] #sidebarToggle,[data-v-22c61ef8] #viewBookmark,[data-v-22c61ef8] #viewFind{display:none!important}", ""]);
// Exports
module.exports = exports;
